import { MaterialIcon } from '@/ui/material-icon'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/ui/dropdown-menu'
import { cn } from '@/shared/lib/utils'
import styles from './PipelineMoreMenu.module.scss'

export type PipelineMoreMenuProps = {
  triggerClassName?: string
  onLockPipeline?: () => void
  onClearCanvas?: () => void
  onDeletePipeline?: () => void
  disableCanvasActions?: boolean
}

export function PipelineMoreMenu({
  triggerClassName,
  onLockPipeline,
  onClearCanvas,
  onDeletePipeline,
  disableCanvasActions = false,
}: Readonly<PipelineMoreMenuProps>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={cn(triggerClassName)} aria-label="Pipeline options">
          <MaterialIcon name="more_horiz" size={22} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={styles.content}
        align="end"
        sideOffset={6}
        alignOffset={0}
      >
        <DropdownMenuItem
          className={styles.item}
          disabled={disableCanvasActions}
          onSelect={() => onLockPipeline?.()}
        >
          <span className={styles.itemIcon} aria-hidden>
            <MaterialIcon name="lock" size={20} />
          </span>
          Lock Canvas
        </DropdownMenuItem>
        <DropdownMenuSeparator className={styles.separator} />
        <DropdownMenuItem
          className={styles.item}
          disabled={disableCanvasActions}
          onSelect={() => onClearCanvas?.()}
        >
          <span className={styles.itemIcon} aria-hidden>
            <MaterialIcon name="block" size={20} />
          </span>
          Clear Canvas
        </DropdownMenuItem>
        <DropdownMenuSeparator className={styles.separator} />
        <DropdownMenuItem
          className={styles.item}
          onSelect={() => onDeletePipeline?.()}
        >
          <span className={styles.itemIcon} aria-hidden>
            <MaterialIcon name="delete_forever" size={20} />
          </span>
          Delete Pipeline
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
